import { useLazyQuery } from "@apollo/client";
import {
  GET_VENUE_RESERVATION_BOUNDS_QUERY,
  GetVenueReservationBoundsQueryInput,
  GetVenueReservationBoundsQueryResponse,
} from "./queries/GetVenueReservationBoundsQuery";
import {
  GET_VENUE_RESERVATION_QUERY,
  GetVenueReservationQueryInput,
  GetVenueReservationQueryResponse,
} from "./queries/GetVenueReservationQuery";
import {
  GET_VENUE_RESERVATIONS_RANGE_QUERY,
  GetVenueReservationsRangeQueryInput,
  GetVenueReservationsRangeQueryResponse,
} from "./queries/GetVenueReservationsQuery";

/**
 * Exposes lazy queries for reservations, bounds, and single reservation data.
 */
export default function useReservationsQueries() {
  const [fetchReservationsQuery, { data, error, loading }] = useLazyQuery<
    GetVenueReservationsRangeQueryResponse,
    GetVenueReservationsRangeQueryInput
  >(GET_VENUE_RESERVATIONS_RANGE_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const [fetchReservationBoundsQuery] = useLazyQuery<
    GetVenueReservationBoundsQueryResponse,
    GetVenueReservationBoundsQueryInput
  >(GET_VENUE_RESERVATION_BOUNDS_QUERY, {
    fetchPolicy: "network-only",
  });

  const [fetchReservation, fetchReservationResult] = useLazyQuery<
    GetVenueReservationQueryResponse,
    GetVenueReservationQueryInput
  >(GET_VENUE_RESERVATION_QUERY);

  return {
    fetchReservationsQuery,
    data,
    error,
    loading,
    fetchReservationBoundsQuery,
    fetchReservation,
    fetchReservationResult,
  };
}
